import { Component } from '@angular/core';

@Component({
  selector: 'app-cards2-examples-9',
  templateUrl: './cards2-examples-9.component.html'
})
export class Cards2Examples9Component {}
